import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Chip, Divider } from "@mui/material";
import api from "../../../utils/api";

const WOStatusHistoryTab = ({ workOrderId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/work-order-status-history/${workOrderId}`)
      .then(r => setHistory(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [workOrderId]);

  const fmtDT = d => d ? new Date(d).toLocaleString() : "N/A";

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight:700, color:"#223142", mb:2 }}>Status History</Typography>
      {loading ? <CircularProgress size={24} /> : history.length === 0 ? (
        <Typography variant="body2" sx={{ color:"#6b778c" }}>No status changes recorded.</Typography>
      ) : (
        <Box sx={{ display:"flex", flexDirection:"column", gap:1.5 }}>
          {history.map((h, i) => (
            <Box key={h.id || i} sx={{ display:"flex", gap:2, alignItems:"flex-start", p:1.5, borderRadius:"10px", bgcolor:"rgba(47,99,173,0.03)", border:"1px solid rgba(47,99,173,0.08)" }}>
              <Box sx={{ flex:1 }}>
                <Box sx={{ display:"flex", alignItems:"center", gap:1, mb:0.5 }}>
                  {h.old_status && <><Chip size="small" label={h.old_status} sx={{ fontWeight:600, fontSize:11, borderRadius:"8px", bgcolor:"rgba(0,0,0,0.06)", color:"#6b778c" }} /><Typography variant="caption" sx={{ color:"#9ca3af" }}>→</Typography></>}
                  <Chip size="small" label={h.new_status} sx={{ fontWeight:700, fontSize:11, borderRadius:"8px", bgcolor:"rgba(47,99,173,0.1)", color:"#2f63ad" }} />
                </Box>
                {h.comment_text && <Typography variant="body2" sx={{ color:"#374151", mt:0.25 }}>{h.comment_text}</Typography>}
                <Typography variant="caption" sx={{ color:"#9ca3af" }}>
                  {h.changed_by_name || "System"} · {fmtDT(h.changed_at)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default WOStatusHistoryTab;
